"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var button_1 = require("@/components/ui/button");
var dropdown_menu_1 = require("@/components/ui/dropdown-menu");
var lucide_react_1 = require("lucide-react");
var LanguageContext_1 = require("../contexts/LanguageContext");
var LanguageSwitcher = function () {
    var _a = (0, LanguageContext_1.useLanguage)(), currentLanguage = _a.currentLanguage, changeLanguage = _a.changeLanguage;
    var languages = [
        { code: 'es', name: 'Español', flag: '🇦🇷' },
        { code: 'en', name: 'English', flag: '🇺🇸' },
        { code: 'fr', name: 'Français', flag: '🇫🇷' },
    ];
    // Google Analytics tracking function
    var trackLanguageChange = function (languageCode, languageName) {
        var gtag = window.gtag;
        if (typeof window !== 'undefined' && gtag) {
            gtag('event', 'language_change', {
                event_category: 'user_preference',
                event_label: "".concat(languageCode, "_").concat(languageName),
                value: 1,
                previous_language: currentLanguage,
                new_language: languageCode
            });
        }
    };
    var handleLanguageChange = function (languageCode) {
        var _a;
        var languageName = ((_a = languages.find(function (lang) { return lang.code === languageCode; })) === null || _a === void 0 ? void 0 : _a.name) || languageCode;
        // Track language change before actually changing it
        trackLanguageChange(languageCode, languageName);
        // Change the language
        changeLanguage(languageCode);
    };
    var currentLang = languages.find(function (lang) { return lang.code === currentLanguage; }) || languages[0];
    return ((0, jsx_runtime_1.jsxs)(dropdown_menu_1.DropdownMenu, { children: [(0, jsx_runtime_1.jsx)(dropdown_menu_1.DropdownMenuTrigger, { asChild: true, children: (0, jsx_runtime_1.jsxs)(button_1.Button, { variant: "ghost", size: "sm", className: "gap-2", children: [(0, jsx_runtime_1.jsx)(lucide_react_1.Globe, { className: "h-4 w-4" }), (0, jsx_runtime_1.jsxs)("span", { className: "hidden sm:inline", children: [currentLang.flag, " ", currentLang.name] }), (0, jsx_runtime_1.jsx)("span", { className: "sm:hidden", children: currentLang.flag })] }) }), (0, jsx_runtime_1.jsx)(dropdown_menu_1.DropdownMenuContent, { align: "end", className: "w-40", children: languages.map(function (language) { return ((0, jsx_runtime_1.jsxs)(dropdown_menu_1.DropdownMenuItem, { onClick: function () { return handleLanguageChange(language.code); }, className: currentLanguage === language.code ? 'bg-accent' : '', children: [(0, jsx_runtime_1.jsx)("span", { className: "mr-2", children: language.flag }), language.name] }, language.code)); }) })] }));
};
exports.default = LanguageSwitcher;
